__turbopack_context__.v({
  "container": "F6DuxG_container",
  "controlsAreHidden": "F6DuxG_controlsAreHidden",
  "leftSide": "F6DuxG_leftSide",
  "overlayContainer": "F6DuxG_overlayContainer",
  "rightSide": "F6DuxG_rightSide",
});
